<template>
  <el-container
    class="login"
    v-loading.fullscreen.lock="fullLoading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    v-if="!isNoLogin"
  >
    <div class="lg-logo"></div>
    <div class="lg-fra">
      <div class="lg-c">
        <div class="lg-title">{{ $l("日立电梯全日+客户服务") }}</div>
        <el-tabs v-model="activeName" stretch @tab-click="handleClickTab">
          <el-tab-pane :label="$l('手机短信登录')" name="phone">
            <el-form ref="form" @keyup.enter.native="login">
              <el-form-item>
                <el-input
                  v-model="user.telNum"
                  :placeholder="$l('手机号')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-row type="flex">
                  <el-input
                    v-model="user.smsCode"
                    class="smsCodeInput"
                    :placeholder="$l('短信验证码')"
                    clearable
                  ></el-input>
                  <el-button
                    type=""
                    class="smsCodeBtn"
                    :title="
                      smsCodeSecondsArr[0] == 0
                        ? $l(smsCodeLabel)
                        : smsCodeTextArr[0]
                    "
                    :disabled="smsCodeSecondsArr[0] > 0"
                    @click="getSmsCode"
                    v-loading.lock="smsLoginLoading"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    >{{
                      smsCodeSecondsArr[0] == 0
                        ? $l(smsCodeLabel)
                        : smsCodeTextArr[0]
                    }}</el-button
                  >
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  :label="$l('记住手机号')"
                  v-model="user.rememberPhone"
                ></el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  block
                  @click="login()"
                  v-loading.lock="loading"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.5)"
                  >LOGIN
                </el-button>
              </el-form-item>
              <el-form-item class="privacy">
                <el-checkbox v-model="isAgreePrivacy">{{
                  $l("我已阅读并同意")
                }}</el-checkbox>
                <span class="privacy-text" @click="openPrivacy()">{{
                  $l("《隐私政策》")
                }}</span>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$l('账号登录')" name="account">
            <el-form ref="form" @keyup.enter.native="login">
              <el-form-item>
                <el-input
                  v-model="user.username"
                  :placeholder="$l('账号')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="user.password"
                  :placeholder="$l('密码')"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item class="va" v-if="showCaptcha">
                <!-- <el-form-item class="va"> -->
                <el-row type="flex">
                  <el-input
                    v-model="user.captcha"
                    :placeholder="$l('验证码')"
                    clearable
                  >
                  </el-input>
                  <img :src="src" @click="getCaptcha" />
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-row type="flex" justify="space-between">
                  <el-checkbox
                    :label="$l('记住账号')"
                    v-model="user.remember"
                  ></el-checkbox>
                  <a href="#" @click="openModifyDialog"
                    >{{ $l("修改密码") }}
                  </a>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  block
                  @click="login()"
                  v-loading.lock="loading"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.5)"
                  >LOGIN
                </el-button>
              </el-form-item>
              <el-form-item class="privacy">
                <el-checkbox v-model="isAgreePrivacy">{{
                  $l("我已阅读并同意")
                }}</el-checkbox>
                <span class="privacy-text" @click="openPrivacy()">{{
                  $l("《隐私政策》")
                }}</span>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>

        <!-- <el-form ref="form" @keyup.enter.native="login" v-if="!isPhoneLogin">
          <el-form-item :label="$l('账号')">
            <el-input placeholder v-model="user.username" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$l('密码')">
            <el-input
              type="password"
              placeholder
              v-model="user.password"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="va" :label="$l('验证码')" v-if="showCaptcha">
            <el-input v-model="user.captcha" clearable>
              <img
                :src="src"
                width="100"
                height="28"
                slot="append"
                @click="getCaptcha"
              />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox
              :label="$l('记住账号')"
              v-model="user.remember"
            ></el-checkbox>
          </el-form-item>
          <el-form-item class="privacy">
            <el-checkbox v-model="isAgreePrivacy">{{
              $l("我已阅读并同意")
            }}</el-checkbox>
            <span class="privacy-text" @click="openPrivacy()">{{
              $l("《隐私政策》")
            }}</span>
          </el-form-item>
          <el-button
            type="primary"
            round
            @click="login()"
            v-loading.lock="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            >Login</el-button
          >
        </el-form>
        <el-form ref="form" @keyup.enter.native="login" v-else>
          <el-form-item :label="$l('手机号')">
            <el-input placeholder v-model="user.telNum" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$l('短信验证码')">
            <el-input
              v-model="user.smsCode"
              class="smsCodeInput"
              clearable
            ></el-input>
            <el-button
              type="primary"
              class="smsCodeBtn"
              :title="
                smsCodeSecondsArr[0] == 0 ? $l(smsCodeLabel) : smsCodeTextArr[0]
              "
              :disabled="smsCodeSecondsArr[0] > 0"
              @click="getSmsCode"
              v-loading.lock="smsLoginLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.5)"
              >{{
                smsCodeSecondsArr[0] == 0 ? $l(smsCodeLabel) : smsCodeTextArr[0]
              }}</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-checkbox
              :label="$l('记住手机号')"
              v-model="user.rememberPhone"
            ></el-checkbox>
          </el-form-item>
          <el-form-item class="privacy">
            <el-checkbox v-model="isAgreePrivacy">{{
              $l("我已阅读并同意")
            }}</el-checkbox>
            <span class="privacy-text" @click="openPrivacy()">{{
              $l("《隐私政策》")
            }}</span>
          </el-form-item>
          <el-button
            type="primary"
            round
            @click="login()"
            v-loading.lock="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            >Login</el-button
          >
        </el-form>
        <a href="#" @click="isPhoneLogin = !isPhoneLogin">{{
          isPhoneLogin ? $l("账号登录") : $l("手机短信登录")
        }}</a
        >&nbsp; -->
        <!-- <a href="#" @click="openRegisterDialog" v-if="isPhoneLogin"
          >{{ $l("注册") }} </a
        >&nbsp; -->
        <!-- <a href="#" @click="openModifyDialog" v-if="!isPhoneLogin"
          >{{ $l("修改密码") }}
        </a> -->
        <div class="title-box">
          <div class="app-query">
            <img :src="qrcodeUrl" />
            <span>{{ $l("移动端搜索“日立电梯”") }}</span>
            <img :src="queryUrl" style="width: 1.5em; margin-right: 20px" />
          </div>
          <!-- <p>{{ $l("IOS版下载渠道：AppStore") }}</p>
          <p>{{ $l("安卓鸿蒙版下载渠道：腾讯应用宝") }}</p> -->
        </div>
        <div class="scan-code">
          <img :src="require('@/assets/img/app_qrcode.jpg')" />
          <img :src="require('@/assets/img/mini_program_code.jpg')" />
        </div>
        <p class="copyright">
          © 2019-2025 bivale.cn 版权所有
          <a href="https://beian.miit.gov.cn" target="_blank"
            >ICP证：粤ICP备19017339 号</a
          >
        </p>
      </div>
    </div>

    <el-dialog
      :title="$l('修改密码')"
      width="500px"
      :visible.sync="modifyPasswordDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="small"
        class="dialog-form"
      >
        <el-form-item :label="$l('账号')" prop="username">
          <el-input placeholder v-model="form.username" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$l('原密码')" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('新密码')" prop="newPassword">
          <el-input
            type="password"
            v-model="form.newPassword"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('确认密码')" prop="rePassword">
          <el-input
            type="password"
            v-model="form.rePassword"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="va" :label="$l('验证码')">
          <el-input v-model="form.captcha" clearable>
            <img
              :src="form.src"
              width="100"
              height="28"
              slot="append"
              @click="getCaptcha"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="modifyPasswordDialogVisible = false">{{
          $l("取消")
        }}</el-button>
        <el-button round type="primary" @click="modifyPasswordSubmit"
          >{{ $l("确定") }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$l('注册')"
      width="500px"
      :visible.sync="registerDialogVisible"
      :close-on-click-modal="false"
      @close="closeRegisterDialog"
    >
      <el-form
        ref="registerForm"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="small"
        class="dialog-form"
      >
        <el-form-item :label="$l('账号')" prop="username">
          <el-input placeholder v-model="form.username" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$l('密码')" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('手机号')" prop="telNum">
          <el-input placeholder v-model="form.telNum" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$l('短信验证码')">
          <el-input v-model="form.smsCode" clearable> </el-input>
          <el-button
            type="primary"
            class="smsCodeBtn"
            :disabled="smsCodeSecondsArr[1] > 0"
            @click="getSmsCode"
            v-loading.lock="smsRegisterLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            >{{
              smsCodeSecondsArr[1] == 0 ? smsCodeLabel : smsCodeTextArr[1]
            }}</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          round
          @click="
            registerDialogVisible = false;
            isRegister = false;
          "
          >{{ $l("取消") }}
        </el-button>
        <el-button round type="primary" @click="registerSubmit"
          >{{ $l("确定") }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$l('隐私政策')"
      width="800px"
      :visible.sync="privacyDialogVisible"
      @close="privacyDialogVisible = false"
      class="privacy-dialog"
    >
      <privacy></privacy>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          round
          @click="
            privacyDialogVisible = false;
            isAgreePrivacy = false;
          "
          >{{ $l("取消") }}
        </el-button>
        <el-button round type="primary" @click="agreePrivacyPolicy"
          >{{ $l("同意") }}
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import global from "@/mixins/global.js";
import privacy from "@/components/privacy.vue";
// import html2canvas from "html2canvas";
// import jsPdf from "jspdf";
// const puppeteer = require("puppeteer");

export default {
  name: "login",
  mixins: [global],
  components: { privacy },
  data() {
    var validateUsername = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入账号")));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(
          new Error(
            this.isPhoneLogin ? this.$l("请输入密码") : this.$l("请输入原密码")
          )
        );
      } else {
        callback();
      }
    };
    var validateNewPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$l("请输入新密码")));
      } else if (!this.$common.validatePassword(value)) {
        callback(
          new Error(
            this.$l("必须包含字母、数字、特殊字符，至少8字符，不超过16个字符")
          )
        );
      } else {
        if (this.form.rePassword !== "") {
          this.$refs.form.validateField("rePassword");
        }
        callback();
      }
    };
    var validateRePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$l("请再次输入密码")));
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$l("两次输入密码不一致")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (
        !value ||
        value.length != 11 ||
        isNaN(value) ||
        value.indexOf(".") >= 0
      ) {
        callback(new Error(this.$l("请输入长度为11位的数字")));
      } else {
        callback();
      }
    };
    return {
      activeName: "phone",
      user: {
        telNum: "",
        username: "",
        password: "",
        captcha: "",
        ctoken: "",
        remember: false,
        rememberPhone: false,
        smsCode: "",
      },
      src: "",
      form: {
        telNum: "",
        username: "",
        password: "",
        newPassword: "",
        rePassword: "",
        captcha: "",
        ctoken: "",
        src: "",
        smsCode: "",
      },
      rules: {
        username: [
          { validator: validateUsername, trigger: "blur" },
          {
            min: 3,
            max: 16,
            message: this.$l("长度在 3 到 16 个字符"),
            trigger: "blur",
          },
        ],
        password: [{ validator: validatePassword, trigger: "blur" }],
        newPassword: [{ validator: validateNewPassword, trigger: "blur" }],
        rePassword: [{ validator: validateRePassword, trigger: "blur" }],
        telNum: [{ validator: validateTelNum, trigger: "blur" }],
      },
      modifyPasswordDialogVisible: false,
      loading: false,
      qrcodeUrl: require("@/assets/img/appicon.png"),
      queryUrl: require("@/assets/svg/login-query.svg"),
      fullLoading: false,
      showCaptcha: false,
      isPhoneLogin: true,
      smsCodeLabel: "获取验证码",
      smsCodeTextArr: ["", ""],
      smsCodeSecondsArr: [0, 0],
      smsCodeTimerArr: [null, null],
      registerDialogVisible: false,
      isRegister: false,
      smsLoginLoading: false,
      smsRegisterLoading: false,
      isNoLogin: false,
      isAgreePrivacy: false,
      privacyDialogVisible: false,
      isAgreeAndLogin: false,
    };
  },
  async created() {
    this.isNoLogin = false;
    const signature = this.$route.query.signature;
    if (signature) {
      this.isNoLogin = true;
      var response = await this.$http.post(
        this.$apiConfig.no_login_signature_auth_url,
        {
          signature: signature.replaceAll(" ", "+"),
        }
      );
      let result = response.data;
      if (result.code == 0) {
        const data = result.data;
        this.user.username = data.username;
        this.user.password = data.password;
        this.login();
      } else {
        this.message(result.code, result.msg);
      }
    }
  },
  mounted() {
    this.user.username = localStorage.getItem("username");
    this.user.remember = this.user.username != null;
    this.user.telNum = localStorage.getItem("telNum");
    this.user.rememberPhone = this.user.telNum != null;
    if (this.showCaptcha) {
      this.getCaptcha();
    }
  },
  methods: {
    login() {
      let password = "";
      if (!this.isNoLogin) {
        if (this.modifyPasswordDialogVisible) {
          return;
        }
        if (!this.isPhoneLogin) {
          this.user.smsCode = "";
          const len = this.user.username ? this.user.username.length : 0;
          if (len < 3 || len > 16) {
            this.message(1, "请输入账号，长度在3到16个字符");
            return;
          }
          if (this.showCaptcha && this.user.captcha.length != 6) {
            this.message(1, "请输入验证码，长度6个字符");
            return;
          }
          password = this.user.password;
          if (!this.$common.validatePassword(password)) {
            this.message(
              1,
              "必须包含字母、数字、特殊字符，至少8字符，不超过16个字符！"
            );
            return;
          }
          if (!this.isAgreePrivacy) {
            this.privacyDialogVisible = true;
            this.isAgreeAndLogin = true;
            return;
          }
          this.user.password = this.$md5(password);
        } else {
          const telNum = this.user.telNum;
          if (
            telNum == null ||
            telNum.length != 11 ||
            isNaN(telNum) ||
            telNum.indexOf(".") >= 0
          ) {
            this.message(1, "请输入手机号，长度为11位的数字");
            return;
          }
          if (!this.user.smsCode || this.user.smsCode.length != 6) {
            this.message(1, "请输入短信验证码，长度6个字符");
            return;
          }
          if (!this.isAgreePrivacy) {
            this.privacyDialogVisible = true;
            this.isAgreeAndLogin = true;
            return;
          }
        }
        this.loading = true;
      }
      this.$http
        .post(this.$apiConfig.user_login_url, this.user)
        .then((response) => {
          let result = response.data;
          console.log(result);
          try {
            if (result.code == 0) {
              this.showCaptcha = false;
              const data = result.data;
              localStorage.removeItem("username");
              if (this.user.remember) {
                localStorage.setItem("username", this.user.username);
              }
              localStorage.removeItem("telNum");
              if (this.user.rememberPhone) {
                localStorage.setItem("telNum", this.user.telNum);
              }
              localStorage.setItem("token", data.token);
              localStorage.setItem("token_timestamp", Date.now());
              localStorage.setItem("user", JSON.stringify(data));
              this.$store.state.user = data;
              const roleId = this.$store.state.user.roleId;
              const roleType = this.$store.state.user.roleType;
              const permissions = data.permissions;
              if (roleType != 1) {
                if (!permissions || permissions.length == 0) {
                  this.message(1, "用户没有菜单权限，不能登录");
                  this.loading = false;
                  this.getCaptcha();
                  return;
                }
                this.$store.state.permissions = permissions;
                localStorage.setItem(
                  "permissions",
                  JSON.stringify(permissions)
                );
              }
              this.message(result.code, result.msg);
              this.$http
                .get(this.$apiConfig.get_role_index_permission_url + roleId)
                .then((res) => {
                  this.loading = false;
                  result = res.data;
                  if (result.code == 0) {
                    const data2 = result.data;
                    this.$store.state.indexPermissions = data2;
                    localStorage.setItem(
                      "indexPermissions",
                      JSON.stringify(data2)
                    );
                    this.$store.state.isLoadIndexPermissions = true;
                  } else {
                    this.$store.state.isLoadIndexPermissions = true;
                  }
                  this.$http
                    .get(this.$apiConfig.get_role_field_permission_url + roleId)
                    .then((response) => {
                      let result = response.data;
                      if (result.code == 0) {
                        let data = result.data;
                        this.$store.state.fieldPermissions = data;
                        localStorage.setItem(
                          "fieldPermissions",
                          JSON.stringify(data)
                        );
                        if (roleType == 1) {
                          this.$router.push({
                            path: "index",
                          });
                        } else {
                          const temps = permissions.filter(
                            (t) => t.name == "index" && t.type == 1
                          );
                          if (temps.length > 0) {
                            this.$router.push({
                              path: temps[0].path,
                            });
                          } else {
                            const routes = this.$router.options.routes;
                            for (let i = 0; i < routes.length; i++) {
                              const item = routes[i];
                              const arr = permissions.filter(
                                (t) => t.name == item.name && t.type == 1
                              );
                              if (arr.length > 0 && item.redirect) {
                                this.$router.push({
                                  path: item.redirect,
                                });
                                break;
                              }
                            }
                          }
                        }
                      }
                    })
                    .catch((error) => {
                      this.loading = false;
                      this.$sentry.captureException(error);
                    });
                })
                .catch((error) => {
                  this.loading = false;
                  this.$store.state.isLoadIndexPermissions = true;
                  this.$sentry.captureException(error);
                });
            } else {
              this.message(result.code, result.msg);
              this.loading = false;
              if (!this.isPhoneLogin) {
                this.user.password = password;
                if (result.data && parseInt(result.data) >= 3) {
                  this.showCaptcha = true;
                } else {
                  this.showCaptcha = false;
                }
                if (this.showCaptcha) {
                  this.getCaptcha();
                }
              } else {
                if (this.smsCodeTimerArr[0]) {
                  clearInterval(this.smsCodeTimerArr[0]);
                  this.smsCodeTextArr[0] = "";
                  this.smsCodeSecondsArr[0] = 0;
                }
              }
            }
          } catch (e) {
            this.loading = false;
            this.$sentry.captureException(error);
          }
        })
        .catch((error) => {
          this.loading = false;
          if (!this.isPhoneLogin) {
            this.user.password = password;
            if (this.showCaptcha) {
              this.getCaptcha();
            }
          }
          this.message(1, "登录失败");
          this.$sentry.captureException(error);
        });
    },
    openModifyDialog() {
      this.modifyPasswordDialogVisible = true;
      for (const key in this.form) {
        this.form[key] = "";
      }
      this.getCaptcha();
    },
    modifyPasswordSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.captcha.length != 6) {
            this.message(1, "请输入验证码，长度6个字符");
            return;
          }
          this.form.username = this.form.username.trim();
          const oldPassword = this.form.password.trim();
          const newPassword = this.form.newPassword.trim();
          if (oldPassword === newPassword) {
            this.message(1, "原密码和新密码不能一样");
            return;
          }
          this.form.password = this.$md5(oldPassword);
          this.form.newPassword = this.$md5(newPassword);
          this.fullLoading = true;
          let data = JSON.parse(JSON.stringify(this.form));
          data.rePassword = "";
          this.$http
            .post(this.$apiConfig.user_login_password_modify_url, data)
            .then((response) => {
              this.fullLoading = false;
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.modifyPasswordDialogVisible = false;
              } else {
                this.form.password = oldPassword;
                this.form.newPassword = newPassword;
                this.form.rePassword = newPassword;
                this.getCaptcha();
              }
            })
            .catch((error) => {
              this.fullLoading = false;
              this.message(1, "修改失败");
              this.form.password = oldPassword;
              this.form.newPassword = newPassword;
              this.form.rePassword = newPassword;
              this.getCaptcha();
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    openRegisterDialog() {
      this.registerDialogVisible = true;
      this.isRegister = true;
      this.$nextTick(() => {
        this.$refs.registerForm.resetFields();
      });
      for (const key in this.form) {
        this.form[key] = "";
      }
    },
    registerSubmit() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (this.form.smsCode.length != 6) {
            this.message(1, "请输入短信验证码，长度6个字符");
            return;
          }
          const password = this.form.password;
          this.form.password = this.$md5(password);
          this.fullLoading = true;
          let data = JSON.parse(JSON.stringify(this.form));
          this.form.password = password;
          this.$http
            .post(this.$apiConfig.user_register_phone_url, data)
            .then((response) => {
              this.fullLoading = false;
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.registerDialogVisible = false;
              }
              if (this.smsCodeTimerArr[1]) {
                clearInterval(this.smsCodeTimerArr[1]);
                this.smsCodeTextArr[1] = "";
                this.smsCodeSecondsArr[1] = 0;
              }
            })
            .catch((error) => {
              if (this.smsCodeTimerArr[1]) {
                clearInterval(this.smsCodeTimerArr[1]);
                this.smsCodeTextArr[1] = "";
                this.smsCodeSecondsArr[1] = 0;
              }
              this.fullLoading = false;
              this.message(1, "注册失败");
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    closeRegisterDialog() {
      this.isRegister = false;
      if (this.smsCodeTimerArr[1]) {
        clearInterval(this.smsCodeTimerArr[1]);
        this.smsCodeTextArr[1] = "";
        this.smsCodeSecondsArr[1] = 0;
      }
    },
    getCaptcha() {
      this.$http
        .get(this.$apiConfig.get_captcha_url, {
          params: {
            t: new Date().getTime(),
            token: this.modifyPasswordDialogVisible
              ? this.form.ctoken
              : this.user.ctoken,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            const ctoken = result.data.token;
            const src = "data:image/jpeg;base64," + result.data.img;
            if (this.modifyPasswordDialogVisible) {
              this.form.src = src;
              this.form.ctoken = ctoken;
            } else {
              this.src = src;
              this.user.ctoken = ctoken;
            }
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    getSmsCode() {
      const index = this.isRegister ? 1 : 0;
      if (this.isRegister && this.smsRegisterLoading) {
        return;
      }
      if (!this.isRegister && this.smsLoginLoading) {
        return;
      }
      if (this.smsCodeSecondsArr[index] > 0) {
        return;
      }
      const telNum = !this.isRegister ? this.user.telNum : this.form.telNum;
      if (
        !telNum ||
        telNum.length != 11 ||
        isNaN(telNum) ||
        telNum.indexOf(".") >= 0
      ) {
        this.message(-1, "请输入手机号长度为11位的数字");
        return;
      }
      if (this.isRegister) {
        this.smsRegisterLoading = true;
      } else {
        this.smsLoginLoading = true;
      }
      this.$http
        .get(this.$apiConfig.get_sms_code_url, {
          params: {
            telNum,
          },
        })
        .then((response) => {
          if (this.isRegister) {
            this.smsRegisterLoading = false;
          } else {
            this.smsLoginLoading = false;
          }
          let result = response.data;
          this.message(result.code, result.msg);
          const code = result.code;
          if (code == 0 || code == 400) {
            this.smsCodeSecondsArr[index] = parseInt(result.data);
            this.smsCodeTextArr[index] = this.smsCodeSecondsArr[index] + "s";
            this.smsCodeTimerArr[index] = window.setInterval(() => {
              this.smsCodeSecondsArr[index]--;
              if (this.smsCodeSecondsArr[index] <= 0) {
                window.clearInterval(this.smsCodeTimerArr[index]);
                this.smsCodeTextArr[index] = "";
                this.smsCodeSecondsArr[index] = 0;
              } else {
                this.smsCodeTextArr[index] =
                  this.smsCodeSecondsArr[index] + "s";
              }
              this.smsCodeTextArr = JSON.parse(
                JSON.stringify(this.smsCodeTextArr)
              );
              this.smsCodeSecondsArr = JSON.parse(
                JSON.stringify(this.smsCodeSecondsArr)
              );
            }, 1000);
          }
        })
        .catch((error) => {
          if (this.isRegister) {
            this.smsRegisterLoading = false;
          } else {
            this.smsLoginLoading = false;
          }
          this.message(-1, "获取失败");
          this.$sentry.captureException(error);
        });
    },
    openPrivacy() {
      this.privacyDialogVisible = true;
      this.isAgreeAndLogin = false;
    },
    agreePrivacyPolicy() {
      this.privacyDialogVisible = false;
      this.isAgreePrivacy = true;
      if (this.isAgreeAndLogin) {
        this.login();
      }
    },

    //切换tab
    handleClickTab(el) {
      if (el.name == "phone") this.isPhoneLogin = true;
      else this.isPhoneLogin = false;
    },
  },
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  background: url("../assets/img/lg_bg.jpg") no-repeat center;
  // background-size: cover;
  background-size: 100% 100%;
  align-items: center;
  justify-content: end;

  .lg-fra {
    width: 33.33%;
    height: 100%;
    // border-radius: $--border-radius-large;
    overflow: hidden;
    // border: 1px solid $--border-color-base;
    background: rgba(#fff, 0.86);
    backdrop-filter: blur(30px);
    display: flex;
    align-items: center;
  }

  .lg-c {
    // font-size: 18px;
    width: 100%;
    font-size: #{"max(0.94vw, 14px)"};
    position: relative;
    // background: #fff;
    // width: 550px;
    padding: 3vh 5vw 0;
    text-align: center;

    > a {
      text-decoration: none;
      display: inline-block;
      margin-top: 10px;
    }

    .scan-code {
      display: flex;
      justify-content: center;
      img {
        width: 5.2vw;
        margin: 0 20px;
        border: 1px solid $--border-color-light;
      }
    }
  }

  .lg-title {
    width: 100%;
    // height: 37px;
    margin: 0px 0 4vh 0px;
    //background: url("../assets/img/ELEPLUS.png") no-repeat left;
    // background-size: 176px 78px;
    font-size: 1.9vw;
    text-align: center;
    font-weight: 600;
    // padding-left: 156px;
  }

  .lg-logo {
    width: 220px;
    height: 50px;
    position: absolute;
    left: 50px;
    top: 40px;
    background: url("../assets/img/logo.png") no-repeat;
    background-size: contain;
  }

  .title {
    width: 360px;
    height: 37px;
    margin-top: 20px;
    margin-bottom: 50px;

    h3,
    p {
      text-align: left;
    }

    h3 {
      font-size: 16px;
      letter-spacing: 1px;
      text-indent: 1px;
    }
  }

  .el-tabs__header {
    margin-bottom: 3vh;
  }
  .el-tabs__item {
    font-size: 1em;
    height: 2.8em;
    line-height: 2.8em;
  }

  .el-form {
    // width: 200px;
    margin: 0 auto;
    text-align: left;
    .el-button {
      // width: 100%;
    }
  }
  .el-button--large {
    font-size: 1em;
    height: 2.8em;
  }

  .el-form-item {
    margin-bottom: 1.5vh;
  }

  .el-input {
    font-size: 1em;
    display: inline-flex;
    .el-input__inner {
      height: 2.8em;
      line-height: 2.8em;
      border-radius: 12px;
      background: #fff;

      // background: transparent;
      // border-width: 0 0 1px 0;
    }

    //   svg {
    //     width: 16px;
    //     margin-left: 4px;
    //     color: $--color-primary;
    //   }
  }

  .el-form-item__label {
    font-size: $--font-size-small;
    color: $--color-text-secondary;
    line-height: 24px;
    float: none;
  }

  .el-form-item__content {
    font-size: inherit;
    margin-left: 0px !important;
  }

  .va .el-form-item__content {
    .el-input-group__append {
      background: transparent;
      border: 0;
      padding-right: 0;
      width: auto;
    }

    img {
      vertical-align: middle;
      margin-left: 12px;
      width: 100px;
      height: 100%;
    }
  }

  .el-form-item__content.el-form-item__content .el-checkbox {
    margin-bottom: 0px;

    .el-checkbox__label {
      font-size: 14px;
    }
  }

  .copyright {
    margin-top: 4vh;
    font-size: $--font-size-small;
    color: $--color-text-secondary;

    a {
      font-size: $--font-size-small;
      color: $--color-text-secondary;
      text-decoration: none;
    }
  }

  // .copyright {
  //   position: relative;
  //   bottom: -110px;
  //   text-align: center;
  //   font-size: $--font-size-small;
  //   color: $--color-text-secondary;
  // }
  .tips {
    margin-top: 2.4em;
    padding: 0 2em;
    font-size: $--font-size-small;
    color: $--color-text-regular;
  }

  a {
    // color: $--color-primary;
    color: $--color-text-regular;
    margin: 0 0.5em;
    text-decoration: none;
    font-size: 14px;
  }

  //加载控件样式
  .el-loading-mask {
    border-radius: 10em;
  }

  .el-loading-spinner {
    margin-top: -8px;
  }

  .smsCodeInput {
    // width: 280px;
  }

  .smsCodeBtn {
    // position: absolute;
    // right: 0px;
    min-width: 8em !important;
    // padding: 9px 5px !important;
    font-size: 1em;
    height: 2.8em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 12px;
    .el-loading-mask {
      border-radius: 0;
    }
  }
}
.title-box {
  border-top: 1px solid $--border-color-light;
  margin-top: 2vh;
  padding-top: 5vh;
  display: flex;
  flex-direction: column;
  font-size: inherit;
  .app-query {
    display: flex;
    height: 2.6em;
    width: 76%;
    margin: auto;
    justify-content: space-between;
    background-color: #ebecef;
    border-radius: 12px;
    align-items: center;
    margin-bottom: 3vh;
    img {
      width: 2.2em;
      object-fit: cover;
      border-radius: 10px;
      margin: 0.2em;
    }
    span {
      font-size: 1em;
      color: #666666;
    }
  }
  p {
    color: $--color-text-secondary;
    font-size: 15px;
    text-align: left;
    margin-top: 10px;
    &:last-child {
      margin-top: 0;
      margin-bottom: 20px;
    }
  }
}
.privacy {
  // margin-top: -12px !important;
  // margin-bottom: 8px !important;
  .privacy-text {
    color: $--color-danger;
    font-size: 13px;
    cursor: pointer;
  }
}
.privacy-dialog {
  .el-dialog__body {
    padding: 10px 20px !important;
    color: black;
  }
}
</style>
